module.exports = __webpack_public_path__ + "static/media/phone1.7dd84ef6.svg";